/**
 * EmptyState.js
 *
 * Component displayed when no data is available
 */

import React from 'react';
import './Shared.css';

/**
 * EmptyState Component
 *
 * Props:
 * - section: Section name (optional)
 * - message: Custom message (optional)
 * - icon: Custom icon (optional)
 * - action: Action object { label: string, onClick: function }
 * - className: Additional CSS classes
 */
const EmptyState = ({
  section = 'Data',
  message = null,
  icon = '📊',
  action = null,
  className = ''
}) => {
  return (
    <div className={`empty-state ${className}`}>
      <div className="empty-icon">{icon}</div>
      <h3 className="empty-title">No {section}</h3>
      <p className="empty-message">
        {message || `No ${section.toLowerCase()} available at the moment.`}
      </p>
      {action && (
        <button className="empty-action-btn" onClick={action.onClick}>
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
